import React, { useState, useEffect } from   'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import { Row, Col, Card, CardBody } from 'react-bootstrap';
import { savePermisosPaginas } from '../Utils/indexedDBUtils';
import { useForm, Controller } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import CargandoSpinner from '../Utils/CargandoSpinner';
registerLocale('es', es);
setDefaultLocale('es');

export default function ReincorporadosApp() {
    const Navigate = useNavigate();
    const { token, fetchPermisosPaginas, rol, nombre } = useAuth();
    const [ Cargando, setCargando] = useState(false);
    const { control, setValue, watch, formState: { errors }} = useForm();
    
    useEffect(() => {
        const consultarPermisosPaginas = async () => {
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        };
        consultarPermisosPaginas();
    }, [token, fetchPermisosPaginas]);
    return (
        <div 
            className="content-wrapper"
            style={{
                backgroundImage: 'url("/dist/img/reinsertados.jpeg")',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                minHeight: '100vh'
            }}
            >
            <section className="content-header">
                <div className="container-fluid">
                    <Card style={{
                        backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                    }}>
                        <CardBody>
                            <h2 className="m-0">Hola, {nombre}</h2>
                            <h4>Te damos la bienvenida a la plataforma VIDAR</h4>
                            <p>Secretaria de Paz y DDHH - Subsecretaría de Justicia Transicional y Restaurativa</p>
                        </CardBody>
                    </Card>
                </div>
            </section>
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    
                </div>
            </section>
        </div>
    )
  }